export const ROUTES = {
  NEW_BOOKING: '/new-booking',
  SELECT_DATE: '/new-booking/select-date',
  PERSONAL_DETAILS: '/new-booking/personal-details',
  MEDICARE: '/new-booking/medicare',
  CONFIRMATION: '/new-booking/confirmation',
  NOTIFICATION: '/notification',
};

export const ROUTE_PREFIX_BOOKING = '/booking';
export const ROUTE_PREFIX_PRE_APPT = '/pre-appt';

export const ROUTES_PRE_APPT = {
  PAYMENT_CONFIRMATION: '/payment-confirmation',
  FINISH_PAYMENT: '/finish-payment',
  NO_APPT: '/no-appt',
  RESCHEDULE: '/reschedule',
};

export const ROUTE_PREFIX_WORKFLOW_ID = '/:workflowId';
export const BASE_URL = '/self-service';
